import { z } from 'zod';
import { normalizePhone } from './format';

/** Sahifalangan ro'yxat javobi — barcha `GET` ro'yxatlar shu shaklda. */
export interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
}

export const MAX_PAGE_SIZE = 200;

/** Ro'yxat so'rovi: `?page=1&pageSize=25&q=...&sort=-createdAt`. */
export const zListQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(25),
  q: z.string().trim().max(200).optional(),
  sort: z
    .string()
    .regex(/^-?[a-zA-Z_][a-zA-Z0-9_]*$/)
    .optional(),
});
export type ListQuery = z.infer<typeof zListQuery>;

export const zUuid = z.uuid();
export const zDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Sana YYYY-MM-DD ko‘rinishida bo‘lishi kerak');

export const zPhone = z
  .string()
  .trim()
  .transform((v, ctx) => {
    const p = normalizePhone(v);
    if (!p) {
      ctx.addIssue({ code: 'custom', message: 'Telefon raqami noto‘g‘ri (+998 XX XXX XX XX)' });
      return z.NEVER;
    }
    return p;
  });

export const zMoney = z.coerce.number().min(0).max(1e13);
export const zSignedMoney = z.coerce.number().min(-1e13).max(1e13);

/** `?ids=a,b,c` yoki massiv. */
export const zIdList = z
  .union([z.string(), z.array(z.string())])
  .transform((v) => (Array.isArray(v) ? v : v.split(',')).map((s) => s.trim()).filter(Boolean));

export const zBoolish = z
  .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
  .transform((v) => v === true || v === 'true' || v === '1');
